// 判断是否在微信中
export var isInWechat = function () {
    var ua = navigator.userAgent.toLowerCase();
    var pattern = /MicroMessenger/i;
    return pattern.test(ua);
};
// 判断是否在企微中
export var isInWxWork = function () {
    var ua = navigator.userAgent.toLowerCase();
    var pattern = /wxwork/i;
    return pattern.test(ua);
};
